import { useAuth } from '@/lib/auth/auth';
import type {
  NotificationPreferencesResponse,
  PatchNotificationPreferencesRequest,
} from '@/lib/api/apiTypes';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const notificationPreferenceKeys = {
  all: ['notification-preferences'] as const,
  current: () => [...notificationPreferenceKeys.all, 'current'] as const,
};

export function useNotificationPreferences() {
  const hasSession = useAuth((state) => Boolean(state.session));
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: notificationPreferenceKeys.current(),
    enabled: hasSession,
    queryFn: () => request<NotificationPreferencesResponse>('/me/notification-preferences'),
  });
}

export function useUpdateNotificationPreferences() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PatchNotificationPreferencesRequest) =>
      request<NotificationPreferencesResponse>('/me/notification-preferences', {
        method: 'PATCH',
        body: JSON.stringify(payload),
      }),
    onSuccess: (data) => {
      queryClient.setQueryData(notificationPreferenceKeys.current(), data);
    },
  });
}
